"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.childClassificationMessages = exports.ChildClassification = void 0;
const schema_1 = require("../../../../schema");
var ChildClassification;
(function (ChildClassification) {
    ChildClassification["A"] = "A";
    ChildClassification["B"] = "B";
    ChildClassification["C"] = "C";
})(ChildClassification || (exports.ChildClassification = ChildClassification = {}));
exports.childClassificationMessages = {
    [ChildClassification.A]: {
        id: "ltx.phaseI.medicalHistory.childPughClassification.childClassification.A",
        defaultMessage: "A"
    },
    [ChildClassification.B]: {
        id: "ltx.phaseI.medicalHistory.childPughClassification.childClassification.B",
        defaultMessage: "B"
    },
    [ChildClassification.C]: {
        id: "ltx.phaseI.medicalHistory.childPughClassification.childClassification.C",
        defaultMessage: "C"
    }
};
const childClassification = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(ChildClassification.A),
    schema_1.Schema.singleChoiceItem(ChildClassification.B),
    schema_1.Schema.singleChoiceItem(ChildClassification.C)
]).interpretation({ vocab: "ltx", code: "child_pugh_classification" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ childClassification });
